import { render } from "./FeaturedGroups.vue?vue&type=template&id=73d7416e"
import script from "./FeaturedGroups.vue?vue&type=script&lang=js"
export * from "./FeaturedGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__